import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class ApiService extends BaseService {
  sendContactData(data: any): Observable<any> {
    const uOb = this.queryPost<any>(
      this.http,
      this.apiUrl('contact-mail'),
      data,
    );
    return uOb;
  }
}
